import React, { useEffect, useState } from "react";
import Styles from "./ChargeView.module.css";
import { useSelector } from "react-redux";
import {
  consumerCharges,
  generatorCharges,
} from "../../../Services/Payments/PaymentApi";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

const ChargeView = ({ open, handleClose }) => {
  const user = useSelector(
    (state) => state?.persistedReducer?.userType
  )?.toLowerCase();
  const id = useSelector(
    (state) =>
      state?.persistedReducer?.user[
        user === "consumer" ? "activeConsumerId" : "activeGeneratorId"
      ]
  );

  const [data, setData] = useState(null);
  console.debug("data111", data);

  const fetchCharges = React.useCallback(async () => {
    try {
      if (user === "consumer") {
        let payload = { consumerIds: [id] };
        let res = await consumerCharges(payload);
        if (res?.data?.code === 200) {
          setData(res?.data?.data?.[0]?.charges);
        }
      }
      if (user === "generator") {
        let payload = { generatorIds: [id] };
        let res = await generatorCharges(payload);
        if (res?.data?.code === 200) {
          setData(res?.data?.data?.[0]?.charges);
        }
      }
    } catch (error) {
      console.error("Error fetching charges:", error);
    } finally {
    }
  }, [id, user]);

  useEffect(() => {
    fetchCharges();
  }, [fetchCharges]);
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.modalMainChargeSelection}`}>
          <div className="modalHeading">
            <div style={{ color: "var(--fourth-color-text)", fontWeight: 500 }}>
              Charge Finalization
            </div>
            <Close
              onClick={handleClose}
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          <div className={Styles.chargeConatiner}>
            <div className={`display_flex_row tableHeading`}>
              <div style={{ width: "40%" }}>Charge Name</div>
              <div style={{ width: "15%" }}>Charge Type</div>
              <div style={{ width: "20%" }}>Value(₹)</div>
              <div style={{ width: "10%" }}>Type</div>
              <div style={{ width: "10%" }}>Editable</div>
            </div>
            <div className={`scroll_bar_y ${Styles.listContainer}`}>
              {data?.map((ele) => (
                <div className={`display_flex_row tableDetails`}>
                  <div style={{ width: "40%" }}>{ele?.name}</div>
                  <div style={{ width: "15%" }}>{ele?.chargeType}</div>
                  <div style={{ width: "20%" }}>{ele?.value}</div>
                  <div style={{ width: "10%" }}>
                    {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                  </div>
                  <div style={{ width: "10%" }}>
                    {ele?.isAdminCharge ? "False" : "True"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ChargeView;
